{
  const STORAGE_KEY = 'nearestLocation';

  function hide(element){
    element.innerHTML = element.innerHTML.replace(/<a\b[^>]*>.*?<\/a>|[^<>]+(?=<)/g, (match) => {
      return match.startsWith('<a') ? match : '';
    });
  }

  function applyLocation(element, nearestLocation) {
    const link = `<a href="${nearestLocation.permalink}">${nearestLocation.post_title}</a>`;
    if (element.innerHTML.includes("Loading...")) {
      element.innerHTML = element.innerHTML.replaceAll("Loading...", link);
    } else {
      element.innerHTML = element.innerHTML.replace(/<a\b[^>]*>.*?<\/a>/, link);
    }
  }

  // derived from the display-formatted phone rather than stored separately
  function phoneHref(phone) {
    const digits = (phone ?? '').replace(/\D/g, '');
    return digits ? `tel:${digits}` : '';
  }

  // the full state (name, address and phone), which is a separate element from the default text above
  function applyDetails(element, nearestLocation) {
    const phoneRow = element.querySelector('.nearest-location-phone');
    const phoneLink = phoneRow.querySelector('a');

    const nameLink = element.querySelector('.nearest-location-summary a');
    nameLink.textContent = nearestLocation.post_title;
    nameLink.href = nearestLocation.permalink;
    nameLink.nextElementSibling.textContent = nearestLocation.address ? `, ${nearestLocation.address}` : '';
    phoneLink.textContent = nearestLocation.phone ?? '';
    phoneLink.href = phoneHref(nearestLocation.phone);
    phoneRow.style.display = nearestLocation.phone ? '' : 'none';
    element.style.display = '';
  }

  // locations cached before address/phone were stored won't have these keys
  function hasDetails(nearestLocation) {
    return 'address' in nearestLocation && 'phone' in nearestLocation;
  }

  function applyToElement(element, nearestLocation) {
    if (element.classList.contains('nearest-location-details')) {
      applyDetails(element, nearestLocation);
    } else {
      applyLocation(element, nearestLocation);
    }
  }

  function requestLocation(element, params) {
    window.coolHelperFunctions.coolAjax(
      {
        action: 'get_nearest_location',
        ...params
      },
      success => {
        if(success?.data?.nearestLocation?.post_title) {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(success.data.nearestLocation));
          applyToElement(element, success.data.nearestLocation);
        } else if (!element.classList.contains('nearest-location-details')) {
          hide(element)
        }
      },
      _error => {
        if (!element.classList.contains('nearest-location-details')) hide(element)
      }
    );
  }

  function updateNearestLocation(element, latitude, longitude) {
    requestLocation(element, { latitude, longitude });
  }

  function setLocationFromCoords(element) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        updateNearestLocation(element, latitude, longitude);
      },
      (_error) => updateNearestLocation(element, 0.0, 0.0)
    );
  }

  document.querySelectorAll('.nearest-location, .nearest-location-details').forEach((element) => {
    const isDetails = element.classList.contains('nearest-location-details');
    let cached = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? 'null');

    if (cached && isDetails && !hasDetails(cached)) {
      if (/^\d+$/.test(cached.post_id)) {
        // a favorited location, so fetch its details instead of looking up the nearest one
        requestLocation(element, { post_id: cached.post_id });
        return;
      }
      cached = null;
    }

    if (cached) {
      applyToElement(element, cached);
    } else if (navigator.geolocation) {
      setLocationFromCoords(element);
    } else {
      updateNearestLocation(element, 0.0, 0.0)
    }
  });

  // dispatched by <favorite-location> when the user picks a different location
  document.addEventListener('nearest-location-change', ({ detail }) => {
    document.querySelectorAll('.nearest-location-details').forEach((element) => applyDetails(element, detail));
  });
}
